﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_infoPageListItem from './tpl/infoPageListItem.html';
import language from '../../../common/language';
import View_Dialog2Button from '../../../lib/views/dialog2Button/dialog2Button';
import * as Entities_Empty from '../../../lib/entities/empty';
import View_LayoutError from '../../../lib/views/layoutError/layoutError';


//export default Marionette.LayoutView.extend({
export default View_LayoutError.extend({

    className: '',
    attributes: function () {
        return {
            style: ''
        }
    },
    getTemplate: function () {
        return tpl_infoPageListItem({ model: this.model.toJSON() });
    },
    initialize: function () {
        this.app = this.options.app;

        //_.bindAll(this, 'toggleService', 'render');
        this.listenTo(this.model, 'change', this.render, this);

        //this.model.on('change', _.bind(this.render, this));

        var nameArray = this.model.attributes.Name.split(' ', 4);
        this.intials = '';

        if (nameArray.length > 0) {
            this.intials += nameArray[0].charAt(0).toUpperCase();
            this.model.attributes.FirstName = nameArray[0];
        }

        this.model.attributes.FirstName = this.model.attributes.Name;

        if (nameArray.length > 1) this.intials += nameArray[1].charAt(0).toUpperCase();
        if (nameArray.length > 2) this.intials += nameArray[2].charAt(0).toUpperCase();
        if (nameArray.length > 3) this.intials += nameArray[3].charAt(0).toUpperCase();

        this.model.attributes.TmpTimespan = '';

        this.model.attributes.TmpActiveTab = this.model.attributes.ActiveTab;
        if (this.model.attributes.TmpActiveTab == 'Webhook') {
            this.model.attributes.TmpActiveTab = resources.X200286;
        } else {
            this.model.attributes.TmpTimeleft = '';
        }

        if (this.model.attributes.ActiveTab == resources.X200311) {
            this.model.attributes.TmpActiveTab = '';
            this.model.attributes.Text = '';
            this.model.attributes.TmpTimestamp = '';
            this.model.attributes.TmpTimeleft = '';
        }
    },
    ui: {
        'infoPageListItem_light': '#infoPageListItem_light',
        'infoPageListItem_profileImage': '#infoPageListItem_profileImage',
        'infoPageListItem_imageUrl': '#infoPageListItem_imageUrl',
        'infoPageListItem_div': '#infoPageListItem_div',
        'infoPageListItem_divName': '#infoPageListItem_divName',
        'infoPageListItem_divActiveTab': '#infoPageListItem_divActiveTab',
        'infoPageListItem_divText': '#infoPageListItem_divText',
        'infoPageListItem_divTimestamp': '#infoPageListItem_divTimestamp',
        'infoPageListItem_divTimeleft': '#infoPageListItem_divTimeleft'
    },
    events: {
    },
    setTmpTimestamp: function () {
        var ret = '';

        if (this.model.attributes.Timestamp != '' && this.model.attributes.Timestamp != null) {


            //var tmpTimestamp = new Date(this.model.attributes.Timestamp + 'Z');

            var sub = '';

            if (this.model.attributes.Timestamp.substr(this.model.attributes.Timestamp.length - 1) == 'Z') {
            }
            else {
                sub = 'Z';
            }

            var utcDate = new Date(this.model.attributes.Timestamp + sub);// + 'Z');
            var utcDateTime = utcDate.getFullYear().toString() + '-' +
                (utcDate.getMonth() + 1) + '-' +
                utcDate.getDate().toString() + 'T' +
                utcDate.getHours() + ':' + utcDate.getMinutes() + ':' + utcDate.getSeconds() + 'Z';

            var utcDateTime2 = new Date(utcDate);
            var utcDisplayDateTime = utcDateTime2.toLocaleDateString() + '-' + utcDateTime2.toLocaleTimeString();

            var onlyTime = utcDateTime2.toLocaleTimeString().substring(0, utcDateTime2.toLocaleTimeString().length - 3);
            utcDisplayDateTime = utcDisplayDateTime.substring(0, utcDisplayDateTime.length - 3);

            //this.model.attributes.Date = utcDateTime2.getDate().toLocaleString();
            //this.model.attributes.Date = utcDateTime2.getMonth().toLocaleString();



            /*this.model.attributes.TmpMessage = this.model.attributes.Message;
            this.model.attributes.TmpMonth = this.getMonth3Letter(utcDateTime2.getMonth() + 1);
            this.model.attributes.TmpDate = utcDateTime2.getDate().toLocaleString();
            this.model.attributes.TmpYear = utcDateTime2.getFullYear();
            this.model.attributes.TmpTime = onlyTime;*/

                ret = onlyTime;
        }


            //if (tmpTimestamp == undefined) {
            //    //tmpTimestamp = new Date();
            //}
            //else {
            //    ret = tmpTimestamp.getHours() + ':' +
            //        tmpTimestamp.getMinutes() + ':' +
            //        tmpTimestamp.getSeconds();
            //}

            //var utcDate = new Date(this.model.attributes.UtcDate + 'Z');

            //var utcDateTime = tmpTimestamp.getFullYear().toString() + '-' +
            //    (tmpTimestamp.getMonth() + 1) + '-' +
            //    tmpTimestamp.getDate().toString() + 'T' +
            //    tmpTimestamp.getHours() + ':' + tmpTimestamp.getMinutes() + ':' + tmpTimestamp.getSeconds() + 'Z';


            //var utcDateTime2 = new Date(utcDate);
            //var utcDisplayDateTime = utcDateTime2.toLocaleDateString() + '-' + utcDateTime2.toLocaleTimeString();

            //var onlyTime = utcDateTime2.toLocaleTimeString().substring(0, utcDateTime2.toLocaleTimeString().length - 3);


            //var localTimestampStr = tmpTimestamp.toLocaleString(window.luxaforboard.config.cultureName, { minimumFractionDigits: 2 });
            //var localTimestamp = new Date(localTimestampStr);
        
        
        return ret;
    },
    setTmpTimespan: function () {
        var ret = '';

        if (this.model.attributes.Timestamp != '') {

            var tmpTimestamp = new Date(this.model.attributes.Timestamp);

            var now = new Date();

            var milliSecondBetweenTwoDate = Math.abs((tmpTimestamp.getTime() - now.getTime()));

            if (milliSecondBetweenTwoDate < 3600) {
                ret = new Date(milliSecondBetweenTwoDate).toISOString().substr(11, 8);
            }
            else {
                ret = new Date(milliSecondBetweenTwoDate).toISOString().substr(14, 5);

            }
        }

        return ret;
    },
    onRender: function () {
        var self = this;
        if (this.model.attributes.Name != '') {
            this.ui.infoPageListItem_div.show();
        }
        else {
            this.ui.infoPageListItem_div.css('display', 'none');
        }
        var nameArray = this.model.attributes.Name.split(' ', 4);
        this.intials = '';

        if (nameArray.length > 0) {
            this.intials += nameArray[0].charAt(0).toUpperCase();
            this.model.attributes.FirstName = nameArray[0];
        }

        this.model.attributes.FirstName = this.model.attributes.Name;

        if (nameArray.length > 1) this.intials += nameArray[1].charAt(0).toUpperCase();
        if (nameArray.length > 2) this.intials += nameArray[2].charAt(0).toUpperCase();
        if (nameArray.length > 3) this.intials += nameArray[3].charAt(0).toUpperCase();

        //this.ui.infoPageListItem_light.css('background-color', this.model.attributes.Color + ' !Important;');

        this.ui.infoPageListItem_light.attr('style', 'background-color:' + this.model.attributes.Color + ' !Important;height: 95px;width:20px;margin-top:5px;');

        this.model.attributes.TmpTimestamp = this.setTmpTimestamp();
        this.model.attributes.TmpTimeleft = this.toHoursAndMinutes(this.model.attributes.Timeleft);

        this.ui.infoPageListItem_profileImage.text(this.intials);

        //this.model.attributes.ImageUrl = null;

        if (this.model.attributes.ImageUrl != null && this.model.attributes.ImageUrl.length > 0) {
            this.ui.infoPageListItem_imageUrl.show();
            this.ui.infoPageListItem_profileImage.css('display', 'none');
        } else {
            this.ui.infoPageListItem_imageUrl.css('display', 'none');
            this.ui.infoPageListItem_profileImage.show();
        }


        var font1_textAlign = this.app.entities.collections.TextAlign.where({
            Value: this.options.module002Model.attributes.Data.Font2_TextAlign
        });

        font1_textAlign[0].attributes.CssStyle.forEach(function (entry) {
            self.ui.infoPageListItem_divName.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divActiveTab.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divText.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divTimestamp.css(entry.Css, entry.Value);
            //self.ui.infoPageListItem_profileImage.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divTimeleft.css(entry.Css, entry.Value);
        });

        this.ui.infoPageListItem_divName.css('font-family', this.options.module002Model.attributes.Data.Font2);
        this.ui.infoPageListItem_divName.css('font-size', this.options.module002Model.attributes.Data.Font2_Size_01);
        this.ui.infoPageListItem_divName.css('color', this.options.module002Model.attributes.Data.Font2_Color);

        this.ui.infoPageListItem_divActiveTab.css('font-family', this.options.module002Model.attributes.Data.Font2);
        this.ui.infoPageListItem_divActiveTab.css('font-size', this.options.module002Model.attributes.Data.Font2_Size_02);
        this.ui.infoPageListItem_divActiveTab.css('color', this.options.module002Model.attributes.Data.Font2_Color);

        this.ui.infoPageListItem_divText.css('font-family', this.options.module002Model.attributes.Data.Font2);
        this.ui.infoPageListItem_divText.css('font-size', this.options.module002Model.attributes.Data.Font2_Size_03);
        this.ui.infoPageListItem_divText.css('color', this.options.module002Model.attributes.Data.Font2_Color);

        this.ui.infoPageListItem_divTimestamp.css('font-family', this.options.module002Model.attributes.Data.Font2);
        this.ui.infoPageListItem_divTimestamp.css('font-size', this.options.module002Model.attributes.Data.Font2_Size_04);
        this.ui.infoPageListItem_divTimestamp.css('color', this.options.module002Model.attributes.Data.Font2_Color);

        this.ui.infoPageListItem_divTimeleft.css('font-family', this.options.module002Model.attributes.Data.Font2);
        this.ui.infoPageListItem_divTimeleft.css('font-size', this.options.module002Model.attributes.Data.Font2_Size_04);
        this.ui.infoPageListItem_divTimeleft.css('color', this.options.module002Model.attributes.Data.Font2_Color);

        this.ui.infoPageListItem_profileImage.css('font-family', this.options.module002Model.attributes.Data.Font2);
        this.ui.infoPageListItem_profileImage.css('font-size', this.options.module002Model.attributes.Data.Font2_Size_05);
        //this.ui.infoPageListItem_profileImage.css('color', this.options.module002Model.attributes.Data.Font2_Color);

        
        var font2_style = this.app.entities.collections.FontStyle.where({
            Value: this.options.module002Model.attributes.Data.Font2_Style
        });

        font2_style[0].attributes.CssStyle.forEach(function (entry) {
            self.ui.infoPageListItem_divName.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divActiveTab.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divText.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divTimestamp.css(entry.Css, entry.Value);
            //self.ui.infoPageListItem_profileImage.css(entry.Css, entry.Value);
            self.ui.infoPageListItem_divTimeleft.css(entry.Css, entry.Value);
        });

        this.model.attributes.TmpActiveTab = this.model.attributes.ActiveTab;
        if (this.model.attributes.TmpActiveTab == 'Webhook') {
            this.model.attributes.TmpActiveTab = resources.X200286;
        } else {
            this.model.attributes.TmpTimeleft = '';
        }

        if (this.model.attributes.ActiveTab == resources.X200311) {
            this.model.attributes.TmpActiveTab = '';
            this.model.attributes.Text = '';
            this.model.attributes.TmpTimestamp = '';
            this.model.attributes.TmpTimeleft = '';
        }

        this.ui.infoPageListItem_divText.text(this.model.attributes.Text);
        this.ui.infoPageListItem_divTimeleft.text(this.model.attributes.TmpTimeleft);
        this.ui.infoPageListItem_divTimestamp.text(this.model.attributes.TmpTimestamp);
        this.ui.infoPageListItem_divActiveTab.text(this.model.attributes.TmpActiveTab);
    },
    onAttach() {
    },
    toHoursAndMinutes: function (totalSeconds) {
        const totalMinutes = Math.floor(totalSeconds / 60);

        var seconds = totalSeconds % 60;
        var hours = Math.floor(totalMinutes / 60);
        var minutes = totalMinutes % 60;

        if (seconds >= 30) {
            seconds = 0;
            minutes += 1;
        }

        var h = '';
        if (hours < 10) h = '0';

        var m = '';
        if (minutes < 10) m = '0';

        var s = '';
        if (seconds < 10) s = '0';

        return h + hours + ':' + m + minutes;// + ':' + s + seconds;
        //return { h: hours, m: minutes, s: seconds };
    }
}, Backbone.Radio.Requests);
